import CryptoJS from "crypto-js";

const SECRET_KEY = "RAJVEER_DEV_2660";

export const encryptValue = (
  value
) => {
  return CryptoJS.AES.encrypt(
    value,
    SECRET_KEY
  ).toString();
};

export const decryptValue = (
  encrypted
) => {
  const bytes =
    CryptoJS.AES.decrypt(
      encrypted,
      SECRET_KEY
    );

  return bytes.toString(
    CryptoJS.enc.Utf8
  );
};